import { getAnalytics } from 'firebase/analytics';
import { app, auth, db } from 'data/firestore/firebase';

const analytics = getAnalytics(app);

export {
    app, auth, db, analytics,
};
